/* ══════════════════════════════════════════════════════════
   BEUTE.STUDIO — AJAX Cart (ausgelagert aus theme.liquid)
   ══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function $(s)   { return document.querySelector(s); }
  function $$(s)  { return Array.from(document.querySelectorAll(s)); }

  var FREE_SHIP_CENTS = 5000; // 50 €

  /* ── Geld formatieren ── */
  function fmt(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ── Logo-Flash gold → grün ── */
  function flashLogo() {
    var el = $('.header-logo');
    if (!el) return;
    el.style.transition = 'filter 0.25s';
    el.style.filter = 'brightness(1.6) sepia(1) saturate(4) drop-shadow(0 0 12px rgba(201,168,76,.9))';
    setTimeout(function () {
      el.style.filter = 'brightness(1.4) sepia(1) saturate(6) hue-rotate(80deg) drop-shadow(0 0 14px rgba(102,187,106,.9))';
    }, 320);
    setTimeout(function () {
      el.style.filter = '';
    }, 950);
  }

  /* ── Drawer öffnen ── */
  function openDrawer() {
    openCart();
  }

  /* ── Badge ── */
  function setBadge(n) {
    $$('.cart-badge').forEach(function (b) {
      b.textContent = n;
      b.style.display = n > 0 ? '' : 'none';
    });
  }

  /* ── Shipping-Bar aktualisieren ── */
  function updateShipping(totalCents) {
    var pct  = Math.min(100, Math.round(totalCents / FREE_SHIP_CENTS * 100));
    var fill = $('#shipping-fill');
    var txt  = $('#shipping-text');
    if (fill) fill.style.width = pct + '%';
    if (!txt) return;
    if (totalCents >= FREE_SHIP_CENTS) {
      txt.innerHTML = '<strong style="color:var(--gold-lt);">✓ Kostenloser Versand inklusive!</strong>';
    } else {
      var rem = ((FREE_SHIP_CENTS - totalCents) / 100).toFixed(2).replace('.', ',');
      txt.innerHTML = 'Noch <strong>' + rem + ' €</strong> bis zum kostenlosen Versand';
    }
  }

  function openCart() {
    var d = $('#cart-drawer'), o = $('#overlay');
    if (d) d.classList.add('open');
    if (o) o.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    var d = $('#cart-drawer'), o = $('#overlay');
    if (d) d.classList.remove('open');
    if (o) o.classList.remove('open');
    document.body.style.overflow = '';
  }

  /* Swipe-to-close */
  (function() {
    var startX = 0, startY = 0;
    document.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    document.addEventListener('touchend', function(e) {
      var d = $('#cart-drawer');
      if (!d || !d.classList.contains('open')) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = Math.abs(e.changedTouches[0].clientY - startY);
      if (dx > 60 && dy < 80) closeCart();
    }, { passive: true });
  })();

  /* ── Kompletten Drawer-Inhalt rendern ── */
  function renderDrawer(cart) {
    setBadge(cart.item_count);
    updateShipping(cart.total_price);

    /* Artikel-Count Badge */
    var countBadge = $('.cd-head__count');
    if (cart.item_count > 0) {
      if (!countBadge) {
        var titleEl = $('.cd-head__title');
        if (titleEl) {
          var span = document.createElement('span');
          span.className = 'cd-head__count';
          span.textContent = cart.item_count;
          titleEl.appendChild(span);
        }
      } else {
        countBadge.textContent = cart.item_count;
        countBadge.style.display = '';
      }
    } else if (countBadge) {
      countBadge.style.display = 'none';
    }

    /* Items-Bereich */
    var itemsEl = $('#cart-items');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML =
        '<div class="cart-empty">' +
          '<svg width="48" height="48" fill="none" stroke="currentColor" stroke-width="1" viewBox="0 0 24 24">' +
            '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>' +
            '<line x1="3" y1="6" x2="21" y2="6"/>' +
            '<path d="M16 10a4 4 0 0 1-8 0"/>' +
          '</svg>' +
          '<p>Dein Warenkorb ist leer</p>' +
          '<a href="/collections/all" class="btn btn-outline" style="margin-top:12px;">Jetzt shoppen</a>' +
        '</div>';

      /* Footer verstecken wenn leer */
      var cdFoot2 = document.getElementById('cd-foot');
      if (cdFoot2) cdFoot2.style.display = 'none';
      return;
    }

    /* Items HTML — neue cd-item Klassen */
    itemsEl.innerHTML = cart.items.map(function (item) {
      var imgTag = item.featured_image && item.featured_image.url
        ? '<img src="' + item.featured_image.url + '" class="cd-item__img" loading="lazy" alt="' + (item.title || '') + '">'
        : '<div class="cd-item__img cd-item__img--ph"></div>';
      var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="cd-item__var">' + item.variant_title + '</p>' : '';
      return (
        '<div class="cd-item" data-key="' + item.key + '">' +
          '<a href="' + item.url + '" class="cd-item__img-wrap">' + imgTag + '</a>' +
          '<div class="cd-item__body">' +
            '<p class="cd-item__name">' + item.product_title + '</p>' +
            variantHtml +
            '<div class="cd-item__row">' +
              '<div class="cd-item__qty">' +
                '<button class="cd-item__qbtn" data-key="' + item.key + '" data-qty="' + Math.max(0, item.quantity - 1) + '" aria-label="Weniger">−</button>' +
                '<span class="cd-item__qnum">' + item.quantity + '</span>' +
                '<button class="cd-item__qbtn" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Mehr">+</button>' +
              '</div>' +
              '<span class="cd-item__price">' + fmt(item.line_price) + '</span>' +
            '</div>' +
            '<button class="cd-item__rm" data-key="' + item.key + '">Entfernen</button>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    /* Footer ein/ausblenden und Preis updaten */
    var cdFoot = document.getElementById('cd-foot');
    if (cdFoot) {
      if (cart.item_count > 0) {
        cdFoot.style.display = '';
        var totalEl = document.getElementById('cd-total-price');
        if (totalEl) totalEl.textContent = fmt(cart.total_price);
      } else {
        cdFoot.style.display = 'none';
      }
    }

    /* Qty- und Remove-Buttons verdrahten */
    $$('.cd-item__qbtn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        cartChange(btn.dataset.key, parseInt(btn.dataset.qty, 10));
      });
    });
    $$('.cd-item__rm').forEach(function (btn) {
      btn.addEventListener('click', function () {
        cartChange(btn.dataset.key, 0);
      });
    });
  }

  /* ── Shopify Cart API: Menge ändern ── */
  function cartChange(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(renderDrawer);
  }

  /* ── Shopify Cart API: Produkt hinzufügen ── */
  function cartAdd(formData, btn) {
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function (r) {
        if (!r.ok) throw new Error();
        return fetch('/cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderDrawer(cart);
        openDrawer();
        flashLogo();
        if (btn) {
          btn.disabled = false;
          btn.innerHTML =
            '<svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">' +
            '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>' +
            '<line x1="3" y1="6" x2="21" y2="6"/>' +
            '<path d="M16 10a4 4 0 0 1-8 0"/></svg> ✓ Hinzugefügt';
          setTimeout(function () {
            btn.innerHTML =
              '<svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">' +
              '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>' +
              '<line x1="3" y1="6" x2="21" y2="6"/>' +
              '<path d="M16 10a4 4 0 0 1-8 0"/></svg> In den Warenkorb';
          }, 2000);
        }
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = 'Fehler – nochmal versuchen'; }
      });
  }

  /* ── Init ── */
  document.addEventListener('DOMContentLoaded', function () {

    /* Formular-Submit abfangen (alle Produktformulare) */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.getAttribute('action') !== '/cart/add') return;
      e.preventDefault();
      cartAdd(new FormData(form), form.querySelector('[type="submit"]'));
    });

    /* Sticky-Bar Button */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.pdp-bar-btn');
      if (!btn) return;
      var form = document.getElementById('pdp-form') || document.getElementById('product-form');
      if (!form) return;
      e.preventDefault();
      cartAdd(new FormData(form), btn);
    });

    /* Drawer-Close */
    document.addEventListener('click', function (e) {
      if (e.target.closest('.cart-close') || e.target.closest('.cd-close') || e.target.id === 'overlay') {
        closeCart();
      }
    });

    /* Cart-Icon öffnet Drawer */
    $$('[data-cart-open]').forEach(function (el) {
      el.addEventListener('click', function () {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          renderDrawer(cart);
          openDrawer();
        });
      });
    });

    /* Badge beim Laden korrekt setzen (echte Shopify-Daten) */
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { setBadge(cart.item_count); });
  });

})();
